import { render, staticRenderFns } from "./SectionStatus.component.vue?vue&type=template&id=63206f69"
import script from "./SectionStatus.component.vue?vue&type=script&lang=js"
export * from "./SectionStatus.component.vue?vue&type=script&lang=js"
import style0 from "./SectionStatus.component.vue?vue&type=style&index=0&id=63206f69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports